// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36tKA","comment":"styles_comment__3BtZI"};